




import Class from './c-chart-tree-map-view';
export default Class;
